/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Field,
  ImageField,
  TextField,
  withDatasourceCheck,
} from "@sitecore-jss/sitecore-jss-nextjs";
import { ComponentProps } from "lib/component-props";
import { OpenDataGroupItem } from "./OpenDataGroupItem";

type OpenDataGroupPageContentProps = ComponentProps & {
  fields: OpenDataGroupFields;
};

export type OpenDataGroupFieldsItemsFieldsFields = {
  Icon?: ImageField | any;
  Title?: TextField | any;
  File?: Field<any>;
};

type OpenDataGroupFieldsItemsFields = {
  id?: string;
  url?: string;
  name?: string;
  displayName?: string;
  fields?: OpenDataGroupFieldsItemsFieldsFields;
};

type OpenDataGroupFields = {
  GroupTitle?: TextField | any;
  Title?: TextField | any;
  Items?: OpenDataGroupFieldsItemsFields[];
};


const OpenDataGroupPageContent = (props: any): JSX.Element => {
  const { Title, GroupTitle, Items } = props?.fields || {};

  return (
    <section className="" aria-labelledby={Title?.value ? "open-data-group-title" : undefined}>
      {Title?.value && (
        <header className="bg-primary-50 pb-10">
          <h1 id="open-data-group-title" className="responsive font-bold text-3xl md:text-4xl md:font-semibold  ">
            {Title?.value}
          </h1>
        </header>
      )}
      {/* content */}
      <div className="responsive py-10 flex flex-col gap-10">
        {GroupTitle?.value && <p className="text-2xl font-semibold">{GroupTitle?.value}</p>}
        {Items && Items?.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {Items?.map((item: OpenDataGroupFieldsItemsFields) => {
              return <OpenDataGroupItem key={item?.id} {...item?.fields} url={item?.url} />;
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default withDatasourceCheck()<OpenDataGroupPageContentProps>(OpenDataGroupPageContent);
